import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import ccr8Img from "@assets/images/ccr8-image.png";
import pd1Img from "@assets/images/pd1-image.png";
import tslpep1Img from "@assets/images/tslpep1-image.png";
import tslpep2Img from "@assets/images/tslpep2-image.png";
import il33ep1Img from "@assets/images/il33ep1-image.png";
import il33ep2Img from "@assets/images/il33ep2-image.png";
import il13ep1Img from "@assets/images/il13ep1-image.png";
import il13ep2Img from "@assets/images/il13ep2-image.png";
import h3haImg from "@assets/images/h3ha-image.png";
import il4raImg from "@assets/images/il4ra-image.png";
import { CountUp } from "countup.js";

import styles from "./index.module.scss";

const Gallery = () => {
  const { t } = useTranslation();

  useEffect(() => {
    const campaigns = new CountUp("campaigns", 10, {
      startVal: 0,
      duration: 3,
    });

    if (!campaigns.error) {
      campaigns.start();
    } else {
      console.error(campaigns.error);
    }

    const bindRate = new CountUp("bindRate", 18.5, {
      startVal: 0,
      duration: 3,
      decimalPlaces: 1,
    });

    if (!bindRate.error) {
      bindRate.start();
    } else {
      console.error(bindRate.error);
    }

    const testedMolecules = new CountUp("testedMolecules", 50, {
      startVal: 999,
      duration: 3,
    });

    if (!testedMolecules.error) {
      testedMolecules.start();
    } else {
      console.error(testedMolecules.error);
    }

    const bestAffinity = new CountUp("bestAffinity", 2, {
      startVal: 999,
      duration: 3,
    });

    if (!bestAffinity.error) {
      bestAffinity.start();
    } else {
      console.error(bestAffinity.error);
    }
  }, []);

  return (
    <div className={styles.pageContainer}>
      <div className={styles.headerContainer}>
        <div className={styles.pageTitle}>{t("galleryPage.title")}</div>
        <div className={styles.pageText}>{t("galleryPage.subtitle")}</div>
      </div>
      <div className={styles.statisticsContainer}>
        <div className={styles.statisticPanel}>
          <div className={styles.title}>
            <span id="campaigns"></span>
          </div>
          <div className={styles.text}>
            {t("galleryPage.statisticPanel.campaigns")}
          </div>
        </div>
        <div className={styles.statisticPanel}>
          <div className={styles.title}>
            <span id="bindRate"></span>%
          </div>
          <div className={styles.text}>
            {t("galleryPage.statisticPanel.bindRate")}
          </div>
        </div>
        <div className={styles.statisticPanel}>
          <div className={styles.title}>
            ≤ <span id="testedMolecules"></span>
          </div>
          <div className={styles.text}>
            {t("galleryPage.statisticPanel.testedMolecules")}
          </div>
        </div>
        <div className={styles.statisticPanel}>
          <div className={styles.title}>
            <span id="bestAffinity"></span> nM
          </div>
          <div className={styles.text}>
            {t("galleryPage.statisticPanel.bestAffinity")}
          </div>
        </div>
      </div>
      <div className={styles.content}>
        <div className={styles.panelContainer}>
          <div className={styles.imageContainer}>
            <img src={ccr8Img} className={styles.img} />
          </div>
          <div className={styles.panelFooter}>
            <div className={styles.title}>CCR8</div>
            <div className={styles.row}>
              <div className={styles.col}>
                <div className={styles.label}>
                  {t("galleryPage.binderType")}
                </div>
                <div className={styles.value}>VHH</div>
              </div>
              <div className={styles.col}>
                <div className={styles.label}>{t("galleryPage.bindRate")}</div>
                <div className={styles.value}>3/23</div>
              </div>
              <div className={styles.col}>
                <div className={styles.label}>
                  {t("galleryPage.bestAffinity")}
                </div>
                <div className={styles.value}>-</div>
              </div>
            </div>
          </div>
        </div>
        <div className={styles.panelContainer}>
          <div className={styles.imageContainer}>
            <img src={pd1Img} className={styles.img} />
          </div>
          <div className={styles.panelFooter}>
            <div className={styles.title}>PD-1</div>
            <div className={styles.row}>
              <div className={styles.col}>
                <div className={styles.label}>
                  {t("galleryPage.binderType")}
                </div>
                <div className={styles.value}>VHH</div>
              </div>
              <div className={styles.col}>
                <div className={styles.label}>{t("galleryPage.bindRate")}</div>
                <div className={styles.value}>1/50</div>
              </div>
              <div className={styles.col}>
                <div className={styles.label}>
                  {t("galleryPage.bestAffinity")}
                </div>
                <div className={styles.value}>224 nM</div>
              </div>
            </div>
          </div>
        </div>
        <div className={styles.panelContainer}>
          <div className={styles.imageContainer}>
            <img src={tslpep1Img} className={styles.img} />
          </div>
          <div className={styles.panelFooter}>
            <div className={styles.title}>TSLP Ep1</div>
            <div className={styles.row}>
              <div className={styles.col}>
                <div className={styles.label}>
                  {t("galleryPage.binderType")}
                </div>
                <div className={styles.value}>VHH</div>
              </div>
              <div className={styles.col}>
                <div className={styles.label}>{t("galleryPage.bindRate")}</div>
                <div className={styles.value}>13/50</div>
              </div>
              <div className={styles.col}>
                <div className={styles.label}>
                  {t("galleryPage.bestAffinity")}
                </div>
                <div className={styles.value}>713 nM</div>
              </div>
            </div>
          </div>
        </div>
        <div className={styles.panelContainer}>
          <div className={styles.imageContainer}>
            <img src={tslpep2Img} className={styles.img} />
          </div>
          <div className={styles.panelFooter}>
            <div className={styles.title}>TSLP Ep2</div>
            <div className={styles.row}>
              <div className={styles.col}>
                <div className={styles.label}>
                  {t("galleryPage.binderType")}
                </div>
                <div className={styles.value}>VHH</div>
              </div>
              <div className={styles.col}>
                <div className={styles.label}>{t("galleryPage.bindRate")}</div>
                <div className={styles.value}>11/50</div>
              </div>
              <div className={styles.col}>
                <div className={styles.label}>
                  {t("galleryPage.bestAffinity")}
                </div>
                <div className={styles.value}>225 nM</div>
              </div>
            </div>
          </div>
        </div>
        <div className={styles.panelContainer}>
          <div className={styles.imageContainer}>
            <img src={il33ep1Img} className={styles.img} />
          </div>
          <div className={styles.panelFooter}>
            <div className={styles.title}>IL33 Ep1</div>
            <div className={styles.row}>
              <div className={styles.col}>
                <div className={styles.label}>
                  {t("galleryPage.binderType")}
                </div>
                <div className={styles.value}>VHH</div>
              </div>
              <div className={styles.col}>
                <div className={styles.label}>{t("galleryPage.bindRate")}</div>
                <div className={styles.value}>6/46</div>
              </div>
              <div className={styles.col}>
                <div className={styles.label}>
                  {t("galleryPage.bestAffinity")}
                </div>
                <div className={styles.value}>346 nM</div>
              </div>
            </div>
          </div>
        </div>
        <div className={styles.panelContainer}>
          <div className={styles.imageContainer}>
            <img src={il33ep2Img} className={styles.img} />
          </div>
          <div className={styles.panelFooter}>
            <div className={styles.title}>IL33 Ep2</div>
            <div className={styles.row}>
              <div className={styles.col}>
                <div className={styles.label}>
                  {t("galleryPage.binderType")}
                </div>
                <div className={styles.value}>VHH</div>
              </div>
              <div className={styles.col}>
                <div className={styles.label}>{t("galleryPage.bindRate")}</div>
                <div className={styles.value}>3/50</div>
              </div>
              <div className={styles.col}>
                <div className={styles.label}>
                  {t("galleryPage.bestAffinity")}
                </div>
                <div className={styles.value}>3.8 μM</div>
              </div>
            </div>
          </div>
        </div>
        <div className={styles.panelContainer}>
          <div className={styles.imageContainer}>
            <img src={il13ep1Img} className={styles.img} />
          </div>
          <div className={styles.panelFooter}>
            <div className={styles.title}>IL13 Ep1</div>
            <div className={styles.row}>
              <div className={styles.col}>
                <div className={styles.label}>
                  {t("galleryPage.binderType")}
                </div>
                <div className={styles.value}>VHH</div>
              </div>
              <div className={styles.col}>
                <div className={styles.label}>{t("galleryPage.bindRate")}</div>
                <div className={styles.value}>9/50</div>
              </div>
              <div className={styles.col}>
                <div className={styles.label}>
                  {t("galleryPage.bestAffinity")}
                </div>
                <div className={styles.value}>556 nM</div>
              </div>
            </div>
          </div>
        </div>
        <div className={styles.panelContainer}>
          <div className={styles.imageContainer}>
            <img src={il13ep2Img} className={styles.img} />
          </div>
          <div className={styles.panelFooter}>
            <div className={styles.title}>IL13 Ep2</div>
            <div className={styles.row}>
              <div className={styles.col}>
                <div className={styles.label}>
                  {t("galleryPage.binderType")}
                </div>
                <div className={styles.value}>VHH</div>
              </div>
              <div className={styles.col}>
                <div className={styles.label}>{t("galleryPage.bindRate")}</div>
                <div className={styles.value}>2/34</div>
              </div>
              <div className={styles.col}>
                <div className={styles.label}>
                  {t("galleryPage.bestAffinity")}
                </div>
                <div className={styles.value}>-</div>
              </div>
            </div>
          </div>
        </div>
        <div className={styles.panelContainer}>
          <div className={styles.imageContainer}>
            <img src={h3haImg} className={styles.img} />
          </div>
          <div className={styles.panelFooter}>
            <div className={styles.title}>H3HA</div>
            <div className={styles.row}>
              <div className={styles.col}>
                <div className={styles.label}>
                  {t("galleryPage.binderType")}
                </div>
                <div className={styles.value}>VHH</div>
              </div>
              <div className={styles.col}>
                <div className={styles.label}>{t("galleryPage.bindRate")}</div>
                <div className={styles.value}>4/34</div>
              </div>
              <div className={styles.col}>
                <div className={styles.label}>
                  {t("galleryPage.bestAffinity")}
                </div>
                <div className={styles.value}>132 nM</div>
              </div>
            </div>
          </div>
        </div>
        <div className={styles.panelContainer}>
          <div className={styles.imageContainer}>
            <img src={il4raImg} className={styles.img} />
          </div>
          <div className={styles.panelFooter}>
            <div className={styles.title}>IL4Ra</div>
            <div className={styles.row}>
              <div className={styles.col}>
                <div className={styles.label}>
                  {t("galleryPage.binderType")}
                </div>
                <div className={styles.value}>VHH</div>
              </div>
              <div className={styles.col}>
                <div className={styles.label}>{t("galleryPage.bindRate")}</div>
                <div className={styles.value}>21/49</div>
              </div>
              <div className={styles.col}>
                <div className={styles.label}>
                  {t("galleryPage.bestAffinity")}
                </div>
                <div className={styles.value}>36 nM</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Gallery;
